module.exports = __webpack_public_path__ + "static/media/intellij.38600d4d.png";